import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  Drawer,
  DocumentsList,
  FormFieldSet,
  LogoLoader,
  PageTitle,
  showToast,
  SmartTooltip,
  TableAdv,
  Modal,
} from "../../../components";
import { dateFormator, mapTableRows } from "../../../utils";
import Chat from "../../../components/Chat/Chat";
import BankingAccordion from "./BankingAccordion";
import JournalEntry from "./Banking/JournalEntry";
import { useLoginUser } from "../../../hooks/useLoginUser";
import { useNavigate } from "react-router-dom";
import { fetchJournalEntry } from "../../../redux/slices/journalEntries/journalEntriesApi";
import { formatCurrency } from "../../../utils/stringUtils";
import { usePagination } from "../../../hooks";
import { set } from "lodash";

const Banking = () => {
  const navigate = useNavigate();
  const notificationRef = useRef(null);
  const { userData: loginUserData } = useLoginUser();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [showNotifications, setShowNotifications] = useState(false);
  const [inputMessage, setInputMessage] = useState("");
  const [date, setDate] = useState("");
  const [showJournalEntry, setShowJournalEntry] = useState(null);
  const [journalEntries, setJournalEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [total, setTotal] = useState(0);
  const [kpiData, setKpiData] = useState({});
  const loginUserId = loginUserData?.uiid;
  const Balance = 55000;
  const [chats, setChats] = useState([
    {
      id: 1,
      senderId: loginUserId,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      timestamp: "2026-01-08T11:52:00Z",
    },
    {
      id: 2,
      senderId: 2,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      timestamp: "2026-01-08T11:53:00Z",
    },
    {
      id: 3,
      senderId: loginUserId,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      timestamp: "2026-01-08T11:54:00Z",
    },
    {
      id: 4,
      senderId: 3,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard Ipsum has been the industry's standard",
      timestamp: "2025-02-05T10:58:00Z",
    },
    {
      id: 5,
      senderId: 3,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      timestamp: "2026-01-08T11:54:00Z",
    },
    {
      id: 6,
      senderId: loginUserId,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      timestamp: "2025-02-05T10:59:00Z",
    },
    {
      id: 7,
      senderId: 2,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      timestamp: "2026-01-08T11:56:00Z",
    },
    {
      id: 8,
      senderId: 2,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard Ipsum has been the industry's standard",
      timestamp: "2025-02-05T11:03:00Z",
      reactions: {
        "😮": {
          count: 1,
          reacted: true,
        },
        "❤️": {
          count: 1,
          reacted: true,
        },
      },
    },
    {
      id: 9,
      senderId: loginUserId,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      timestamp: "2026-01-08T11:57:00Z",
    },
    {
      id: 10,
      senderId: loginUserId,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      timestamp: "2025-02-05T11:05:00Z",
    },
    {
      id: 11,
      senderId: loginUserId,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard",
      timestamp: "2026-01-08T11:57:00Z",
    },
    {
      id: 12,
      senderId: loginUserId,
      message:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard Ipsum has been the industry's standard",
      timestamp: "2025-03-05T10:52:00Z",
      replyTo: {
        messageId: 12,
        message:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard Ipsum has been the industry's standard",
        senderName: "Tektree Software",
        senderId: 2,
      },
    },
  ]);

  const { page, limit, setPage, handleLimitChange } = usePagination(10);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewDocs, setViewDocs] = useState([]);
  const [viewTitle, setViewTitle] = useState("");

  const formatAttachments = (attachments = []) =>
    (attachments || [])
      .map((attachment) => {
        if (!attachment) return null;
        if (typeof attachment === "string") {
          return {
            name: attachment.split("/").pop() || attachment,
            filePath: attachment,
          };
        }
        if (typeof attachment === "object") {
          return {
            name:
              attachment.name ||
              attachment.filePath?.split("/").pop() ||
              attachment.key ||
              "Attachment",
            filePath: attachment.filePath || attachment.key || attachment.url || "",
          };
        }
        return null;
      })
      .filter(Boolean);

  const loadJournalEntries = async () => {
    setLoading(true);
    try {
      const response = await fetchJournalEntry({
        page,
        limit,
        ref: "AddedBy UpdatedBy",
        incl: ["firstName lastName", "firstName lastName"],
        filters: {
          ...(searchTerm && {
            all: {
              type: "SEARCH",
              value: searchTerm,
            },
          }),
        },
      });
      const data = response?.data || [];
      setJournalEntries(Array.isArray(data) ? data : data?.data || []);
      setTotal(response?.totalCount?.data || 0);
    } catch (error) {
      showToast(
        error?.message || "Failed to load journal entries",
        "error",
        3000,
      );
    } finally {
      setLoading(false);
    }
  };
  const fetchOpeningBalance = async () => {
    try {
      const response = await fetchJournalEntry({
        useAggregate: true,
        filters: {
          all: {
            type: "AG_OPENING_BALANCE",
            value: null,
          },
        },
      });
      setKpiData(response?.data?.data?.[0] || {});
    } catch (error) {
      showToast(
        error?.message || "Failed to load journal entries",
        "error",
        3000,
      );
    }
  };
  useEffect(() => {
    loadJournalEntries();
    fetchOpeningBalance();
  }, [page, limit, searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications]);

  const users = [
    {
      id: loginUserData?.uiid,
      name: "Raghu",
      profilePhotoUrl: loginUserData?.profilePhotoUrl,
    },
    {
      id: 2,
      name: "Tektree Software",
      profilePhotoUrl: "https://avatars.githubusercontent.com/u/34077875",
    },
    {
      id: 3,
      name: "Admin",
      profilePhotoUrl: "https://randomuser.me/api/portraits/men/44.jpg",
    },
  ];
  const toggleAccordion = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  // Group chats by date
  const groupChatsByDate = () => {
    const grouped = {};
    chats.forEach((chat) => {
      const date = new Date(chat.timestamp)
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "-");
      if (!grouped[date]) grouped[date] = [];
      grouped[date].push(chat);
    });
    return Object.entries(grouped).map(([date, messages]) => ({
      date,
      messages,
    }));
  };

  const chatsByDate = groupChatsByDate();

  //mapping
  const rows = journalEntries.map((entry) => {
    //append zeros
    const journalId = entry.uiid
      ? `JR-${String(entry.uiid).padStart(2, "0")}`
      : "-";
    return {
      id: entry.uiid,
      // date: entry.date
      //   ? new Date(entry.date)
      //       .toLocaleDateString("en-GB", {
      //         day: "2-digit",
      //         month: "2-digit",
      //         year: "numeric",
      //       })
      //       .replace(/\//g, "-")
      //   : "-",
      date: dateFormator(entry.date) || "-",
      transactionDetails: entry.description || "-",
      // journalId: entry.uiid || "-",
      journalId,
      debit: entry?.debit ? entry.debit : "",
      credit: entry?.credit ? entry.credit : "",
      balance: entry?.balance ? entry.balance : "0.00",
      // debit: entry?.debit ? formatCurrency(entry.debit) : "",
      // credit: entry?.credit ? formatCurrency(entry.credit) : "",
      // balance: entry?.balance ? formatCurrency(entry.balance) : "0.00",
      attachments: entry.attachments || [],
      activities: entry?.activities || [],
      metaData: entry,
    };
  });

  const rowsDummy = [
    {
      id: 1,
      date: "02-01-2026",
      transactionDetails: "Client Payment Received - Computer Aid Inc",
      journalId: "JR-001",
      debit: "+1000.00",
      credit: "-",
      balance: "1000.00",

      attachments: [
        new File(["dummy content"], "customer-un-happy-v4.html", {
          type: "text/html",
        }),
      ],
    },
    {
      id: 2,
      date: "03-01-2026",
      transactionDetails: "Office Rent Payment - January",
      journalId: "JR-002",
      debit: "",
      credit: "1000.00",
      balance: "1000.00",
    },
    {
      id: 3,
      date: "04-01-2026",
      transactionDetails: "Internet Service Charges",
      journalId: "JR-003",
      debit: "",
      credit: "189.00",
      balance: "189.00",
    },
    {
      id: 4,
      date: "05-01-2026",
      transactionDetails: "Freelance Project Income",
      journalId: "JR-004",
      debit: "+600.00",
      credit: "",
      balance: "600.00",
    },
    {
      id: 5,
      date: "06-01-2026",
      transactionDetails: "Software Subscription Payment",
      journalId: "JR-005",
      debit: "",
      credit: "4590.00",
      balance: "4590.00",
    },
    {
      id: 6,
      date: "07-01-2026",
      transactionDetails: "Equipment Purchase - Laptops",
      journalId: "JR-006",
      debit: "",
      credit: "6788.00",
      balance: "6788.00",
    },
    {
      id: 7,
      date: "08-01-2026",
      transactionDetails: "Travel Expenses - Client Meeting",
      journalId: "JR-007",
      debit: "",
      credit: "6788.00",
      balance: "6788.00",
    },
    {
      id: 8,
      date: "09-01-2026",
      transactionDetails: "Bulk Order Payment Received",
      journalId: "JR-008",
      debit: "+8940.00",
      credit: "",
      balance: "8940.00",
    },
    {
      id: 9,
      date: "10-01-2026",
      transactionDetails: "Consultation Fee Received",
      journalId: "JR-009",
      debit: "+3466.00",
      credit: "",
      balance: "3466.00",
    },
    {
      id: 10,
      date: "11-01-2026",
      transactionDetails: "Utility Bill Payment - Electricity",
      journalId: "JR-0010",
      debit: "",
      credit: "5670.00",
      balance: "5670.00",
    },
  ];

  const columns = [
    {
      key: "date",
      label: "Date",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.date}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.date}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "transactionDetails",
      label: "Transaction Details",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.transactionDetails}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.transactionDetails}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "journalId",
      label: "Journal ID",
      width: "min-w-[150px]! max-w-[200px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.journalId}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.journalId}</div>
        </SmartTooltip>
      ),
    },
    // {
    //   key: "attachments",
    //   label: "Attachments",
    //   width: "min-w-[150px]! max-w-[200px]!",
    //   render: (row) => {
    //     const docs = (row?.attachments || [])
    //       .map((attachment) => {
    //         if (!attachment) return null;
    //         if (typeof attachment === "string") {
    //           return {
    //             name: attachment.split("/").pop() || attachment,
    //             filePath: attachment,
    //           };
    //         }
    //         if (typeof attachment === "object") {
    //           return {
    //             name:
    //               attachment.name ||
    //               attachment.filePath?.split("/").pop() ||
    //               attachment.key ||
    //               "Attachment",
    //             filePath: attachment.filePath || attachment.key || attachment.url || "",
    //           };
    //         }
    //         return null;
    //       })
    //       .filter(Boolean);

    //     return docs.length > 0 ? (
    //       <div className="text-sm text-gray-700">
    //         {docs.length} attachment{docs.length > 1 ? "s" : ""}
    //       </div>
    //     ) : (
    //       <div className="text-gray-400">No attachments</div>
    //     );
    //   },
    // },
    {
      key: "debit",
      label: "Debit",
      width: "min-w-[150px]! max-w-[200px]!",
      total: true,
      render: (row) => (
        <SmartTooltip
          description={row?.debit}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.debit}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "credit",
      label: "Credit",
      width: "min-w-[150px]! max-w-[200px]!",
      total: true,
      render: (row) => (
        <SmartTooltip
          description={row?.credit}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.credit}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "balance",
      label: "Balance",
      width: "min-w-[150px]! max-w-[200px]!",
      total: true,
      render: (row) => (
        <SmartTooltip
          description={row?.balance}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.balance}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "view",
      label: "View",
      render: (row) => (
        <SmartTooltip
          description={"View"}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <Button
            type="icon"
            size="sm"
            icon={"visibility"}
            variant="text"
            color="black"
            onClick={() => {
              setViewDocs(formatAttachments(row?.attachments || []));
              setViewTitle(row?.journalId || row?.transactionDetails || "Attachments");
              setViewModalOpen(true);
            }}
          />
        </SmartTooltip>
      ),
    },
    {
      key: "action",
      label: "Action",
      render: (row) => {
        const isOpen = expandedRows[row.id];

        return (
          <div className="flex items-center gap-1">
            {/* Edit */}
            <SmartTooltip
              description="Edit"
              size="xs"
              color="black"
              noicon
              tooltipPosition="bottom"
              portal={true}
            >
              <Button
                type="icon"
                size="sm"
                icon="edit_square"
                variant="text"
                color="black"
                onClick={() =>
                  navigate(`/off-trx/journal-entry/edit/${row?.id}`, {
                    state: { data: row?.metaData || {} },
                  })
                }
              // onClick={() => {
              //   setShowJournalEntry({
              //     mode: "edit",
              //     data: row,
              //   });
              // }}
              />
            </SmartTooltip>

            {/* Toggle Accordion */}
            <SmartTooltip
              size="xs"
              color="black"
              noicon
              tooltipPosition="bottom"
              portal={true}
              description={isOpen ? "Collapse" : "Expand"}
            >
              <Button
                type="icon"
                size="lg"
                icon={isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                variant="text"
                color="black"
                onClick={() => toggleAccordion(row.id)}
              />
            </SmartTooltip>
          </div>
        );
      },
    },
  ];

  const notifications = [
    {
      id: 1,
      userName: "Vikranth",
      time: "9 hours ago",
      message: "Billable Client: Computer Aid Inc, Period",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
      showActions: true,
    },
    {
      id: 2,
      userName: "Vikranth",
      time: "9 hours ago",
      message: "Billable Client: Computer Aid Inc, Period",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
      showActions: false,
    },
    {
      id: 3,
      userName: "Vikranth",
      time: "9 hours ago",
      message: "Billable Client: Computer Aid Inc, Period",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
      showActions: false,
    },
  ];
  const handleDecline = (id) => {
    showToast(`Declined for ${id}`, "error");
  };

  const handleApprove = (id) => {
    showToast(`Approved for ${id}`, "success");
  };

  const handleSendMessage = (replyTo) => {
    const trimmed = inputMessage?.trim();
    if (!trimmed) return;

    const newChat = {
      id: chats?.length + 1,
      senderId: loginUserId,
      message: trimmed,
      timestamp: new Date().toISOString(),
      replyTo: replyTo
        ? {
          messageId: replyTo.message?.id,
          message: replyTo.message?.message,
          senderName: replyTo.sender?.name,
          senderId: replyTo?.sender?.id,
        }
        : null,
    };

    setChats((prev) => [...prev, newChat]);
    setInputMessage("");
  };
  const handleDeleteMessage = (messageId) => {
    setChats((prev) => prev.filter((chat) => chat.id !== messageId));
  };
  const handleReactMessage = (messageId, emoji) => {
    setChats((prev) =>
      prev.map((chat) => {
        if (chat.id !== messageId) return chat;

        const existing = chat.reactions?.[emoji];
        const updatedReactions = { ...chat.reactions };

        if (existing?.reacted) {
          if (existing.count <= 1) delete updatedReactions[emoji];
          else
            updatedReactions[emoji] = {
              count: existing.count - 1,
              reacted: false,
            };
        } else {
          updatedReactions[emoji] = {
            count: (existing?.count || 0) + 1,
            reacted: true,
          };
        }

        return { ...chat, reactions: updatedReactions };
      }),
    );
  };

  // if (showJournalEntry) {
  //   return (
  //     <JournalEntry
  //       mode={showJournalEntry.mode}
  //       editData={showJournalEntry.data}
  //       onBack={() => setShowJournalEntry(null)}
  //     />
  //   );
  // }

  const handleSearch = (keyname, value) => {
    setSearchTerm((a) => (value ? value : ""));
  };

  //TODO: inProgress: api data
  const mappedRows = mapTableRows(rows, columns);
  // dummy data test
  // const mappedRows = mapTableRows(rowsDummy, columns);

  return (
    <>
    {import.meta.env.VITE_APP_ENV === "local" && (
                <div className="flex items-center justify-end col-span-2 w-max-[50px] gap-2">
                  <Button
                    onClick={() => {
                      console.groupCollapsed("--- New Log Session ---");
                      console.groupEnd();
                      loadJournalEntries();
                    }}
                    variant="outlined"
                    icon="autorenew"
                    title={"Load Entries"}
                  />
                  <Button
                    onClick={() => {
                      console.groupCollapsed("--- New Log Session ---");
                      console.groupEnd();
                      fetchOpeningBalance();
                    }}
                    variant="outlined"
                    icon="autorenew"
                    title={"Load Opening Balance"}
                  />
                </div>
              )}
      <div className="flex flex-1 flex-col overflow-auto">
        <div className="flex justify-between items-center my-5">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              padding: "16px 20px",
              background: "#fff",
              borderLeft: "4px solid #FF6B00",
              width: "fit-content",
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
              borderRadius: "4px",
            }}
          >
            <span style={{ fontWeight: 600, fontSize: "16px", color: "#333" }}>
              Opening Balance
            </span>
            <div style={{ display: "flex", alignItems: "baseline", gap: "8px" }}>
              <span style={{ fontWeight: 700, fontSize: "20px", color: "#111" }}>
                ₹ {kpiData?.openingBalance}
              </span>
              {kpiData?.totalActivityImpact > 0 && <span style={{ fontSize: "14px", color: "#dc2626", fontWeight: "500" }}>
                (-₹ {kpiData?.totalActivityImpact})
              </span>}
            </div>
          </div>
          {/* old design*/}
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              padding: "16px 20px",
              background: "#fff",
              borderLeft: "4px solid #FF6B00",
              width: "fit-content",
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
              borderRadius: "4px",
            }}
          >
            <span style={{ fontWeight: 600, fontSize: "16px", color: "#333" }}>
              Opening Balance
            </span>
            <span style={{ fontWeight: 700, fontSize: "20px", color: "#111" }}>
              ₹ {kpiData?.openingBalance}
            </span> <span style={{ fontWeight: 700, fontSize: "20px", color: "#111" }}>
              Impact:  {kpiData?.totalActivityImpact}
            </span>
          </div>*/}
          <div className="flex items-center gap-2">
            <div className="relative">
              <Button
                type="icon"
                icon={"notifications"}
                variant="text"
                color="black"
                onClick={() => setShowNotifications((prev) => !prev)}
              />
            </div>
            <Button
              type="icon"
              icon={"chat"}
              variant="text"
              color="black"
              onClick={() => setDrawerOpen(true)}
            />
            <Button
              title={"Journal Entry"}
              icon={"add"}
              variant={"outlined"}
              onClick={() => navigate("/off-trx/journal-entry/create")}
            // onClick={() =>
            //   setShowJournalEntry({
            //     mode: "create",
            //   })
            // }
            />
          </div>
        </div>
        <div>
          <PageTitle title={"Offshore Transaction History"} className="text-primary" />
        </div>

        <TableAdv
          tableId={"off-trx"}
          showSlNo
          rows={mappedRows}
          columns={columns}
          expandedRows={expandedRows}
          serverOnSearch={handleSearch}
          serverSearchValue={searchTerm}
          serverPagination={true}
          totalCount={total}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: true,
            add: [
              {
                component: (
                  <div className="flex items-center gap-2">
                    <FormFieldSet
                      size="sm"
                      type="datepicker"
                      value={date}
                      onChange={setDate}
                      noTitle
                      showDropdown={false}
                      placeholder="Select Date"
                    />
                  </div>
                ),
              },
            ],
          }}
          accordion={(row) => {
            return expandedRows[row?.id] ? <BankingAccordion uiid={row?.id} activities={row?.activities}/> : null;
          }}
        />

        <Drawer
          isOpen={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          position="right"
          width="w-[40%]"
          titleBgColor="primary"
          title={
            <div className="flex items-center gap-2 px-8 py-4">
              <Avatar size="xxl" alt="tektree" src="/Tektree_logo.png" />
              <span className="font-semibold text-md text-white">
                Tektree Software
              </span>
            </div>
          }
          closeOnOutsideClick
          bodyGap={false}
        >
          <Chat
            chatsByDate={chatsByDate}
            users={users}
            loginUserId={loginUserId}
            showInput={true}
            inputMessage={inputMessage}
            onInputChange={setInputMessage}
            onSendMessage={handleSendMessage}
            loginUserAvatarUrl={loginUserData?.profilePhotoUrl}
            loginUserAvatarAlt="user"
            onDeleteMessage={handleDeleteMessage}
            onReactMessage={handleReactMessage}
          // showActions={false}
          />
        </Drawer>
        <Modal
          isOpen={viewModalOpen}
          onClose={() => setViewModalOpen(false)}
          width="max-w-2xl"
          title={viewTitle || "Attachments"}
        >
          <div className="p-4">
            {viewDocs.length > 0 ? (
              <DocumentsList data={viewDocs} />
            ) : (
              <div className="text-gray-500">No attachments available</div>
            )}
          </div>
        </Modal>

        {/* Notifications */}
        {showNotifications && (
          <div
            ref={notificationRef}
            className="absolute right-0 w-[370px] bg-white shadow-lg border-gray-300 border z-50"
          >
            <div className="flex justify-between items-center px-4 py-3">
              <span className="font-semibold text-gray-700">Notification</span>
              <Button
                type="icon"
                icon={"close"}
                variant="text"
                onClick={() => setShowNotifications(false)}
              />
            </div>

            <div className="max-h-[400px] overflow-auto">
              {notifications?.map((item) => (
                <div
                  key={item?.id}
                  className="flex items-start gap-3 px-4 py-3 border-b border-gray-200 hover:bg-gray-50 transition"
                >
                  <img src={item?.avatar} className="w-10 h-10 rounded-full" />

                  <div className="flex-1">
                    <div className="text-xs text-gray-400">
                      {item?.time}{" "}
                      <span className="text-gray-600">{item?.userName}</span>
                    </div>

                    <div className="text-sm text-gray-700">{item?.message}</div>

                    <div className="flex gap-2 mt-2">
                      <Button
                        title="Decline"
                        variant="outlined"
                        color="danger"
                        onClick={() => handleDecline(item?.id)}
                      />
                      <Button
                        title="Approved"
                        color="success"
                        onClick={() => handleApprove(item?.id)}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </>
  );
};

export default Banking;
